import { APIMethod, fetchData } from "@client";

export async function setCompanySettingsQuery(key, value) {
  await fetchData("/company/settings/", APIMethod.POST, {
    data: { key, value: typeof value === "string" ? value : JSON.stringify(value) },
  });
}
